import { createFileRoute } from '@tanstack/react-router'

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card'
import {
  FirmNameForm,
  InviteMemberDialog,
  MembersList,
  PendingInvitations,
  useAccount,
  useFetchMembers,
} from '@/modules/account'

export const Route = createFileRoute('/_authenticated/settings/')({
  staticData: { title: 'Settings' },
  component: SettingsPage,
})

function SettingsPage() {
  const isOwner = useAccount()?.isOwner
  useFetchMembers()

  return (
    <div className="mx-auto max-w-2xl space-y-6 p-6">
      <h1 className="text-2xl font-bold">Settings</h1>

      {isOwner && (
        <Card>
          <CardHeader>
            <CardTitle>Firm Details</CardTitle>
            <CardDescription>Update your firm's display name.</CardDescription>
          </CardHeader>
          <CardContent>
            <FirmNameForm />
          </CardContent>
        </Card>
      )}

      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Team Members</CardTitle>
              <CardDescription>
                People who have access to this account.
              </CardDescription>
            </div>
            {isOwner && <InviteMemberDialog />}
          </div>
        </CardHeader>
        <CardContent>
          <MembersList />
        </CardContent>
      </Card>

      {isOwner && (
        <Card>
          <CardHeader>
            <CardTitle>Pending Invitations</CardTitle>
            <CardDescription>
              Invitations that haven't been accepted yet.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <PendingInvitations />
          </CardContent>
        </Card>
      )}
    </div>
  )
}
